<template>
  <div id="app" class="main-wrapper">
    <router-view />
  </div>
</template>


<script>

export default {
  name: 'App'
};
</script>
